import BrandLogo from './BrandLogo'

/** Logo 5em, alinhada à direita com a borda da marca (login). */
export default function AuthBrandHeader() {
  return (
    <div className="flex flex-col items-end w-fit mx-auto px-2">
      <BrandLogo
        className="h-[5em] w-auto max-w-[min(100%,380px)] object-contain object-right"
        alt="Automais"
      />
    </div>
  )
}
